// extracted by mini-css-extract-plugin
export default {"detail_qr":"QrField_detail_qr__NFv84","field_title":"QrField_field_title__5oHmM","field_content_qr":"QrField_field_content_qr__H3LN1","content":"QrField_content__+WM8C"};